export const mediaItems = [
  {
    id: 1,
    title: '《星际穿越》诺兰科幻巨制',
    description: '震撼视觉，IMAX级观影体验，高清画质流畅不卡顿',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20spacecraft%20near%20a%20massive%20black%20hole%2C%20cinematic%20lighting%20with%20warm%20golden%20accents%2C%20dramatic%20composition%2C%20high%20contrast%20deep%20space%20background%2C%20film%20grain%20texture%2C%20widescreen%20aspect%20ratio&width=640&height=360&seq=media-01&orientation=landscape',
    tag: '科幻巨制',
    duration: '2h 49min',
    quality: '4K',
  },
  {
    id: 2,
    title: '《流浪地球3》国产科幻新高度',
    description: '国产视效巅峰之作，太阳危机再临，人类命运抉择',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20earth%20with%20massive%20engines%20propelling%20the%20planet%20through%20space%2C%20epic%20cinematic%20shot%20with%20warm%20orange%20and%20teal%20color%20grading%2C%20dramatic%20clouds%20and%20atmosphere%2C%20film%20poster%20quality&width=640&height=360&seq=media-02&orientation=landscape',
    tag: '国产大片',
    duration: '2h 53min',
    quality: '4K HDR',
  },
  {
    id: 3,
    title: '《封神第二部》神话史诗续章',
    description: '太师闻仲率大军出征西岐，神仙斗法场面升级',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20epic%20battle%20scene%20with%20warriors%20in%20armor%2C%20dramatic%20sky%20with%20golden%20light%2C%20cinematic%20composition%2C%20grand%20scale%20war%20scene%2C%20warm%20and%20rich%20color%20palette%2C%20film%20quality&width=640&height=360&seq=media-03&orientation=landscape',
    tag: '神话史诗',
    duration: '2h 28min',
    quality: '4K',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '8848影院的片源画质怎么样？',
    answer: '8848影院全站影片均支持高清1080P和超清4K画质，采用先进的视频编码技术，在保证画质清晰的同时大幅降低带宽消耗，让您在普通网络下也能流畅观看高清内容。无论是最新大片还是经典老片，我们都提供最佳观看体验。',
  },
  {
    id: 2,
    question: '真的能做到秒开不缓冲吗？',
    answer: '是的！8848影院采用全球CDN加速节点和智能预加载技术，视频打开速度比传统影院快3-5倍。我们自研的流媒体分发引擎能够根据您的网络状况实时调整播放策略，真正做到即点即播、流畅不卡顿。',
  },
  {
    id: 3,
    question: '需要注册才能观看吗？',
    answer: '完全不需要！8848影院坚持免费开放的理念，所有影片均可免注册直接观看。无需会员，无需登录，打开网站就能畅享海量影视资源，我们相信好内容应该让每个人都能轻松触达。',
  },
  {
    id: 4,
    question: '影片资源更新频率如何？',
    answer: '我们保持每日更新的节奏，院线下映的热门影片通常在1-2周内上线，热门剧集同步更新。同时我们的片库也在持续扩充，涵盖动作、科幻、喜剧、爱情、惊悚、动画等全品类内容，目前已收录超过5万部影视作品。',
  },
  {
    id: 5,
    question: '支持哪些设备观看？',
    answer: '8848影院全面适配PC、平板和手机端，无论您用什么设备访问，都能获得最佳的观看体验。我们采用响应式设计，自动适配不同屏幕尺寸，手机端还支持手势控制亮度、音量和进度。',
  },
  {
    id: 6,
    question: '观看时需要安装播放器吗？',
    answer: '无需安装任何播放器或插件。8848影院基于HTML5技术构建，所有主流浏览器均可直接播放，包括Chrome、Safari、Edge和Firefox。即开即看，省去繁琐的安装步骤。',
  },
];

export const topicItems = [
  { id: 1, name: '科幻巨制', count: '2.3w', hot: true },
  { id: 2, name: '国产动画', count: '1.8w', hot: true },
  { id: 3, name: '悬疑烧脑', count: '1.5w', hot: true },
  { id: 4, name: '喜剧合家欢', count: '1.2w', hot: false },
  { id: 5, name: '动作大片', count: '2.1w', hot: true },
  { id: 6, name: '韩剧热播', count: '1.6w', hot: false },
  { id: 7, name: '美剧经典', count: '9.8k', hot: false },
  { id: 8, name: '纪录片精选', count: '7.2k', hot: false },
  { id: 9, name: '恐怖惊悚', count: '1.1w', hot: false },
  { id: 10, name: '日漫番剧', count: '1.9w', hot: true },
];

export const commentItems = [
  {
    id: 1,
    author: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%20with%20warm%20tones%2C%20simple%20clean%20illustration%20style%2C%20soft%20background&width=48&height=48&seq=avatar-01&orientation=squarish',
    date: '2小时前',
    content: '8848的播放体验真的绝了！之前在其他站看4K经常卡，这边居然真的秒开，画质还一点不打折。强烈推荐《星际穿越》4K版，音画体验拉满！',
    likes: 328,
    movie: '《星际穿越》',
  },
  {
    id: 2,
    author: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%20with%20cool%20tones%2C%20simple%20clean%20illustration%20style%2C%20soft%20background&width=48&height=48&seq=avatar-02&orientation=squarish',
    date: '5小时前',
    content: '片库太全了，找了好久的冷门老片居然都有。更新速度也快，上周刚上映的片子这两天就上了。8848影院已经是我每天必打开的网站了。',
    likes: 256,
    movie: '《封神第二部》',
  },
  {
    id: 3,
    author: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%20with%20neutral%20tones%2C%20simple%20clean%20illustration%20style%2C%20soft%20background&width=48&height=48&seq=avatar-03&orientation=squarish',
    date: '1天前',
    content: '手机端体验意外的好，地铁上看了两集剧全程流畅，还能手势调亮度音量。不注册不花钱，这种良心网站值得推荐给身边所有人。',
    likes: 189,
    movie: '《流浪地球3》',
  },
  {
    id: 4,
    author: '电影老炮儿',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20portrait%20with%20earthy%20tones%2C%20simple%20clean%20illustration%20style%2C%20soft%20background&width=48&height=48&seq=avatar-04&orientation=squarish',
    date: '2天前',
    content: '用了三个月了，从没遇到过卡顿和缓冲。画质清晰度基本可以媲美会员平台，但人家是免费的。更新快、片源多、体验好，确实做到了他们说的"不缓冲秒开"。',
    likes: 412,
    movie: '《奥本海默》',
  },
];

export const updateItems = [
  {
    id: 1,
    date: '2026-08-01',
    title: '《死侍与金刚狼》4K高清版上线',
    description: '漫威年度动作喜剧巨制，死侍与金刚狼强强联手，带来前所未有的爆笑冒险。4K HDR画质，即点即播。',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '播放引擎升级至v3.2版本',
    description: '全新升级的流媒体引擎上线，加载速度提升40%，内存占用降低25%，弱网环境下也能流畅播放高清内容。',
    tag: '系统升级',
  },
  {
    id: 3,
    date: '2026-07-28',
    title: '《沙丘3》独家加长版上线',
    description: '新增30分钟未公开内容，导演剪辑加长版，史诗级视觉奇观，4K杜比全景声沉浸式体验。',
    tag: '独家内容',
  },
  {
    id: 4,
    date: '2026-07-25',
    title: '新增日本动画专题频道',
    description: '收录近年热门番剧及经典作品，包括《鬼灭之刃》《间谍过家家》《葬送的芙莉莲》等高分动画。',
    tag: '频道上线',
  },
  {
    id: 5,
    date: '2026-07-22',
    title: '韩剧频道更新：10部高分剧集',
    description: '《黑暗荣耀》《财阀家的小儿子》《Moving超异能族》等口碑韩剧全系列上线，高清中字完整版。',
    tag: '剧集更新',
  },
  {
    id: 6,
    date: '2026-07-20',
    title: 'CDN节点扩容至全球120+',
    description: '新增东南亚、欧洲和北美加速节点，海外用户观影体验大幅提升，全球范围内均可流畅高清观看。',
    tag: '网络优化',
  },
  {
    id: 7,
    date: '2026-07-18',
    title: '《奥本海默》4K导演版上线',
    description: '诺兰年度力作，横扫奥斯卡多项大奖，4K超高清画质还原每一帧IMAX胶片质感，震撼心灵。',
    tag: '新片上线',
  },
];

export const appData = {
  title: '多端畅享 · 随时随地高清观影',
  description: '8848影院全面适配手机、平板和电脑。无需下载APP，浏览器访问即可享受完整观影体验。支持手势控制、投屏播放、画中画模式，让你无论在家还是出行都能流畅观影。',
  features: ['响应式自适应', '手势亮度音量', '画中画模式', '投屏播放', '离线缓存'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20and%20tablet%20showing%20movie%20streaming%20interface%20with%20dark%20theme%20and%20gold%20accents%2C%20modern%20minimal%20device%20mockup%20on%20dark%20background%2C%20cinematic%20movie%20posters%20displayed%20on%20screen%2C%20clean%20UI%20design&width=600&height=400&seq=app-mockup&orientation=portrait',
};

export const aboutData = {
  title: '关于8848影院',
  description: '8848影院是一个致力于提供极致观影体验的免费在线影视平台。我们深知"缓冲"是观影最大的敌人，因此自建全球CDN加速网络，自研流媒体分发引擎，只为让你打开视频的那一刻就能流畅播放。\n\n平台收录超过5万部影视作品，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。我们的编辑团队每日精选优质内容，让你在海量片库中快速找到想看的作品。\n\n8848影院坚持免费开放的理念，不设会员门槛，无需注册登录，所有内容均可直接观看。我们相信，好的内容应该让每个人都能轻松享受。',
  stats: [
    { label: '影视资源', value: '50000+' },
    { label: '每日更新', value: '50+' },
    { label: '日均访问', value: '200万+' },
    { label: 'CDN节点', value: '120+' },
  ],
};

export const cardItems = [
  {
    id: 1,
    title: '暑期科幻季',
    description: '精选20部硬核科幻大片，从《星际穿越》到《沙丘》，畅享宇宙级视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20collage%20with%20spaceships%20and%20galaxies%2C%20dark%20cinematic%20style%20with%20warm%20gold%20accent%20lighting%2C%20dramatic%20composition%2C%20movie%20poster%20quality&width=480&height=300&seq=card-01&orientation=landscape',
    tag: '专题合集',
    count: '20部精选',
  },
  {
    id: 2,
    title: '国漫崛起之路',
    description: '从《哪吒》到《长安三万里》，见证国产动画的华丽蜕变与无限可能',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20traditional%20ink%20painting%20elements%20and%20modern%20CGI%20blend%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20lighting%2C%20epic%20composition&width=480&height=300&seq=card-02&orientation=landscape',
    tag: '专题合集',
    count: '35部精选',
  },
  {
    id: 3,
    title: '韩剧高分精选',
    description: '豆瓣8分以上韩剧全收录，从悬疑到爱情，一部不落尽享韩流魅力',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20warm%20autumn%20colors%2C%20cinematic%20composition%20with%20soft%20bokeh%20background%2C%20emotional%20atmosphere%2C%20film%20quality%20lighting&width=480&height=300&seq=card-03&orientation=landscape',
    tag: '高分推荐',
    count: '50部精选',
  },
  {
    id: 4,
    title: '诺兰电影宇宙',
    description: '克里斯托弗·诺兰全作品回顾，从《记忆碎片》到《奥本海默》',
    image: 'https://readdy.ai/api/search-image?query=Christopher%20Nolan%20film%20aesthetic%20with%20complex%20geometric%20patterns%20and%20time%20themes%2C%20dark%20cinematic%20style%20with%20blue-gold%20contrast%2C%20intellectual%20atmosphere&width=480&height=300&seq=card-04&orientation=landscape',
    tag: '导演专题',
    count: '12部全收录',
  },
  {
    id: 5,
    title: '悬疑烧脑合集',
    description: '高智商必看！精心挑选的烧脑神作，每一部都让你欲罢不能',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20atmosphere%20with%20dramatic%20shadows%20and%20warm%20accent%20light%2C%20suspenseful%20cinematic%20composition%2C%20film%20noir%20inspired%20lighting%2C%20dark%20and%20moody&width=480&height=300&seq=card-05&orientation=landscape',
    tag: '烧脑推荐',
    count: '28部精选',
  },
];

export const contactData = {
  title: '联系我们',
  description: '如果你有影片推荐、合作建议或任何反馈，欢迎通过以下方式联系我们。8848影院始终倾听每一位用户的声音。',
  email: 'contact@8848cinema.com',
  wechat: '8848cinema',
  tips: '工作时间：周一至周日 9:00 - 22:00，我们会在24小时内回复您的来信。',
};

export const carouselItems = [
  {
    id: 1,
    title: '暑期档必看TOP10',
    description: '这个夏天最值得看的十部大片，从科幻巨制到温情喜剧，每一部都值得你花时间沉浸其中。8848影院全片4K高清上线。',
    image: 'https://readdy.ai/api/search-image?query=Summer%20blockbuster%20movie%20collage%20with%20explosive%20action%20scenes%2C%20warm%20golden%20hour%20cinematic%20lighting%2C%20dramatic%20composition%2C%20movie%20poster%20quality%2C%20epic%20scale&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '编辑精选',
    badge: 'HOT',
  },
  {
    id: 2,
    title: 'IMAX级视觉盛宴',
    description: '精选视觉震撼影片，4K超清画质搭配杜比全景声，在家也能享受影院级的视听体验。8848影院让每一帧画面都栩栩如生。',
    image: 'https://readdy.ai/api/search-image?query=IMAX%20cinema%20experience%20with%20massive%20screen%20showing%20epic%20landscape%20scene%2C%20dramatic%20lighting%2C%20grand%20scale%2C%20cinematic%20atmosphere%2C%20rich%20contrast&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '视觉专题',
    badge: '4K',
  },
  {
    id: 3,
    title: '国产电影年度盘点',
    description: '2026年上半年最值得关注的国产电影全收录，从票房黑马到口碑佳作，8848影院与你一同见证中国电影的崛起之路。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20cinema%20celebration%20with%20red%20and%20gold%20festive%20elements%2C%20film%20reel%20motif%2C%20warm%20cinematic%20lighting%2C%20elegant%20composition%2C%20prestigious%20award%20ceremony%20atmosphere&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '年度盘点',
    badge: '精选',
  },
  {
    id: 4,
    title: '周末电影马拉松',
    description: '精选6部高分电影，从周五夜晚到周日傍晚，8848影院陪你度过一个完美的电影周末。全程高清流畅，不卡顿不缓冲。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20warm%20ambient%20lighting%2C%20large%20screen%20showing%20movie%2C%20comfortable%20atmosphere%2C%20cinematic%20color%20grading%2C%20relaxed%20weekend%20vibe&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '观影指南',
    badge: '推荐',
  },
];

export const indexItems = [
  { id: 1, category: '动作', title: '动作大片', count: 3200, icon: 'ri-fire-line' },
  { id: 2, category: '科幻', title: '科幻巨制', count: 1800, icon: 'ri-rocket-line' },
  { id: 3, category: '喜剧', title: '喜剧合家欢', count: 2500, icon: 'ri-emotion-laugh-line' },
  { id: 4, category: '爱情', title: '爱情文艺', count: 2100, icon: 'ri-heart-line' },
  { id: 5, category: '悬疑', title: '悬疑烧脑', count: 1600, icon: 'ri-search-eye-line' },
  { id: 6, category: '动画', title: '动画世界', count: 2800, icon: 'ri-movie-line' },
  { id: 7, category: '纪录', title: '纪录精选', count: 1200, icon: 'ri-global-line' },
  { id: 8, category: '恐怖', title: '恐怖惊悚', count: 900, icon: 'ri-ghost-line' },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '秒开播放',
    description: '全球CDN加速，即点即播，告别缓冲等待，观影体验如丝般顺滑',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '全站支持1080P与4K超清，先进编码技术在保证画质的同时节省流量',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    description: '无弹窗广告，无恶意跳转，纯净观影环境让你沉浸于每一部好片',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '极速更新',
    description: '每日更新50+内容，院线新片快速上线，热播剧集同步追更不落伍',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '《死侍与金刚狼》', category: '动作 / 喜剧', score: 9.2, trend: 'up' },
  { id: 2, rank: 2, title: '《沙丘3》', category: '科幻 / 冒险', score: 9.0, trend: 'up' },
  { id: 3, rank: 3, title: '《奥本海默》', category: '传记 / 历史', score: 9.3, trend: 'stable' },
  { id: 4, rank: 4, title: '《封神第二部》', category: '神话 / 史诗', score: 8.8, trend: 'up' },
  { id: 5, rank: 5, title: '《流浪地球3》', category: '科幻 / 灾难', score: 8.7, trend: 'stable' },
  { id: 6, rank: 6, title: '《长安三万里》', category: '动画 / 历史', score: 8.9, trend: 'up' },
];